var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("h2", [_vm._v(_vm._s(_vm.$t("InvestmentReport.Menu.BasicInfo")))]),
    _vm._v(" "),
    _c("div", [
      _vm.isBudgetaryEstimate
        ? _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.Instructions.PrefillInstructionsBudgetaryEstimate"
                )
              )
            )
          ])
        : _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.Instructions.PrefillInstructionsFinalReport"
                )
              )
            )
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "ml-3" }, [
        _c("ul", [
          _c("li", [_vm._v(_vm._s(_vm.$t("AidTargetNumber")))]),
          _vm._v(" "),
          _c("li", [_vm._v(_vm._s(_vm.$t("Purpose")))]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.BasicInfo.AidTargetDecisionTerms")
              )
            )
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.GrantedAmounts")))
          ]),
          _vm._v(" "),
          _c("li", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.BasicInfo.AidPercentForInstructions")
              )
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
    _vm._v(" "),
    _vm.isSupportApartments
      ? _c("div", [
          _c("p", { staticClass: "question" }, [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.BasicInfo.SupportApartments.StartTime")
              )
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.BasicInfo.SupportApartments.StartTime_Instructions"
                )
              )
            )
          ])
        ])
      : _c("div", [
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.StartTime")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.BasicInfo.StartTime_Instructions")
              )
            )
          ])
        ]),
    _vm._v(" "),
    _vm.isSupportApartments
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(
              _vm._s(
                _vm.$t("InvestmentReport.BasicInfo.SupportApartments.EndTime")
              )
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "InvestmentReport.BasicInfo.SupportApartments.EndTime_Instructions"
                )
              )
            )
          ])
        ])
      : _c("div", [
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.EndTime")))
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(_vm.$t("InvestmentReport.BasicInfo.EndTime_Instructions"))
            )
          ])
        ]),
    _vm._v(" "),
    _vm.isICT || _vm.isBudgetaryEstimate
      ? _c("div", [
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _c("p", { staticClass: "question" }, [
            _vm._v(_vm._s(_vm.$t("InvestmentReport.BasicInfo.TenderStatus")))
          ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "Enums.InvestmentTenderStatus.PutOutToTenderAccordingToLaw"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("Enums.InvestmentTenderStatus.RequestedOffers"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("Enums.InvestmentTenderStatus.NotPutOutToTender")
                  )
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml-3" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "question" }, [
              _vm._v(
                _vm._s(_vm.$t("InvestmentReport.BasicInfo.NoTenderExplanation"))
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.isPremises
      ? _c("div", [
          !_vm.isBudgetaryEstimate
            ? _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
                _vm._v(" "),
                _c("p", { staticClass: "question" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$t("InvestmentReport.BasicInfo.InvestmentTarget")
                    )
                  )
                ]),
                _vm._v(" "),
                _c("ul", [
                  _c("li", [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "Enums.PremisesInvestmentType.OfficeAndBusinessPremises"
                          )
                        )
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("Enums.PremisesInvestmentType.Residence"))
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("b", [
                      _vm._v(
                        _vm._s(_vm.$t("Enums.PremisesInvestmentType.Other"))
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "ml-3" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.$t("Instructions.FurtherDescription")))
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "question" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "InvestmentReport.BasicInfo.OtherTargetDescription"
                        )
                      )
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _vm.isBudgetaryEstimate
            ? _c("p", { staticClass: "question" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.TitleBudgetaryEstimate"
                    )
                  )
                )
              ])
            : _c("p", { staticClass: "question" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.TitleFinalReport"
                    )
                  )
                )
              ]),
          _vm._v(" "),
          _vm.isBudgetaryEstimate
            ? _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.TitleBudgetaryEstimate_Instructions"
                    )
                  )
                )
              ])
            : _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.TitleFinalReport_Instructions"
                    )
                  )
                )
              ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("InvestmentReport.BasicInfo.TargetInfo.BusinessId")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.BusinessId_Instructions"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("InvestmentReport.BasicInfo.TargetInfo.RealEstateId")
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.RealEstateId_Instructions"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.TargetInfo.ConstructionYear"
                    )
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _vm.isBudgetaryEstimate
              ? _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t("InvestmentReport.BasicInfo.TargetInfo.IsOwn")
                      )
                    )
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.isBudgetaryEstimate
              ? _c("li", [
                  _c("b", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "InvestmentReport.BasicInfo.TargetInfo.OwnershipExplanation"
                        )
                      )
                    )
                  ])
                ])
              : _vm._e()
          ]),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.$t("Instructions.Question")))]),
          _vm._v(" "),
          _vm.isBudgetaryEstimate
            ? _c("p", { staticClass: "question" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.Address.TitleBudgetaryEstimate"
                    )
                  )
                )
              ])
            : _c("p", { staticClass: "question" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.Address.TitleFinalReport"
                    )
                  )
                )
              ]),
          _vm._v(" "),
          _vm.isBudgetaryEstimate
            ? _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.Address.TitleBudgetaryEstimate_Instructions"
                    )
                  )
                )
              ])
            : _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "InvestmentReport.BasicInfo.Address.TitleFinalReport_Instructions"
                    )
                  )
                )
              ]),
          _vm._v(" "),
          _c("ul", [
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("InvestmentReport.BasicInfo.Address.Postal"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(
                    _vm.$t("InvestmentReport.BasicInfo.Address.PostalCode")
                  )
                )
              ])
            ]),
            _vm._v(" "),
            _c("li", [
              _c("b", [
                _vm._v(
                  _vm._s(_vm.$t("InvestmentReport.BasicInfo.Address.City"))
                )
              ])
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }